import React, {useEffect, useState} from 'react';
import { MdWhatsapp} from 'react-icons/md';
import FAQ from '../components/FAQ';


function Chat(){
     
    const api_url = "/api";

    async function LogPage(){
      
       try{
      
      const response = await fetch(`${api_url}/views`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name: "FAQ",
            view: "FAQPage"
        }),
        });
      const data = await response.json();
      if(!response.ok){
        throw new Error(data.message || "Upload failed");
      }
      console.log(data)
     
       }catch(error){
         console.error("Failed to log view:", error);
       }
    }

    const QnAs = [
        {
            question: "Does Your Jewelry Fade?",
            answer: 'Our jewelry does not fade, we sell stainless and titanium steel jewelry that does not fade, react or tarnish',
            questionId:1
        },
         {
            question: "How Do I make a purchase?",
            answer: 'You can purchase by following these steps: 1 - click on the item you want to buy, 2 - choose the size, 3 - click the add to cart to button, 4 - click the proceed to checkout , 5 - after verifying that you got everything you wanted to buy click the proceed to checkout button, 6 - enter your phone number, 7 - click the make payment button, 8 - choose the payment button and proceed to make the payment, 9 - when you see the receipt page click the dowbload receipt button, 10 - after payment is made you will be messaged with delivery details',
            questionId: 2
        },
        {
            question: "Do you do delivery?",
            answer: 'Yes, after payment is made, delivery will be done through yango biker if you are in lusaka and platinum outside lusaka',
            questionId: 3
        },
        {
            question: "Where are you located?",
            answer: 'We operate primarily online but are based in kabwata, lusaka deliveries will be done from kabwata, outside lusaka orders will be done from lusaka at your cost',
            questionId: 4
        },
         {
            question: "Do you do special packing?",
            answer: 'The necklaces come already boxed and jewelry sets come boxed. If you want special cards added to the packaging or special rose boxes, you can text us on whatsapp for special packaging instructions on whatsapp at an extra fee.',
            questionId: 5
        }
    ]

    useEffect(()=>{
         LogPage()
       },[])

    function handleClick(question){
        setQuestionId(question)
    }

   const [questionId, setQuestionId] = useState("")

   return(
    <div className='flex one column gap'>
      <div className='flex one center'>
         <p className='bold'>Frequently Asked Questions (FAQs)</p>
      </div>
      {QnAs.length > 0 && QnAs.map(item =>(
        <FAQ question={item.question} answer={item.answer} questionId={item.questionId}  currentQuestion={questionId} onClick={handleClick}/>
      ))}
      <div className='flex one center'>
              
      </div>
      <div className='flex one center'>
        <div className='checkout-btn flex space-evenly center-align' onClick={()=>window.open('https://wa.me/260973666651', '_blank')}>
            <span className='white-txt'>Contact Sales Rep on Whatsapp</span>
             <MdWhatsapp size={25} className='white'/>
        </div>
      </div>
    </div>
   )
}

export default Chat